/**
 * Configuration for monitoring tools
 * Allows enabling/disabling specific monitoring systems
 */
export interface MonitoringToolsConfig {
  /**
   * Enable/disable Google Tag Manager monitoring
   * @default true
   */
  gtm?: boolean;

  /**
   * Enable/disable Smartlook monitoring
   * @default true
   */
  smartlook?: boolean;

  /**
   * Enable/disable PostHog monitoring
   * @default true
   */
  posthog?: boolean;

  /**
   * Enable/disable Microsoft Clarity monitoring
   * @default true
   */
  clarity?: boolean;
}

/**
 * Default configuration with all monitoring tools enabled
 */
export const DEFAULT_MONITORING_CONFIG: MonitoringToolsConfig = {
  gtm: true,
  smartlook: true,
  posthog: true,
  clarity: true,
};
